<mat-grid-list cols="2" rowHeight="380px" gutterSize="1rem">
  <mat-grid-tile>
    <mat-card [style.width]="'98%'">
      <mat-card-content>
        <mat-form-field>
          <mat-label>Body</mat-label>
          <textarea
            matInput
            cols="100"
            rows="12"
            [style.resize]="'none'"
            [formControl]="httpBody"
            >{{ convertBodyValue(httpBody.value ?? '') }}</textarea
          >
        </mat-form-field>
      </mat-card-content>
    </mat-card>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-card [style.width]="'98%'" [style.height]="'97%'">
      <mat-card-header>
        <mat-card-title> Testing endpoints: </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <br />
        <ul>
          <li>
            GET /oauth/v2/keys
            <ul>
              <li>
                Should return HTTP 200 and a valid response without any token
              </li>
            </ul>
          </li>
          <li>
            POST /keys
            <ul>
              <li>
                Should return HTTP 501 with ID Token (will be 20x when
                implemented)
              </li>
              <li>Should return HTTP 403 with Access Token or No Token</li>
            </ul>
          </li>
          <li>
            PATCH /keys/&#123;keyId&#125;
            <ul>
              <li>
                Should return HTTP 501 with ID Token (will be 20x when
                implemented)
              </li>
              <li>Should return HTTP 403 with Access Token or No Token</li>
            </ul>
          </li>
          <li>
            Please note that the 'authorization' header is expected in
            lowercase, which is default regardless of source capitalization if
            HTTP/2 is used. In Postman, this setting must be changed. We may
            need to triage this as a bug later on.
          </li>
        </ul>
      </mat-card-content>
    </mat-card>
  </mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-card [style.width]="'99%'">
      <mat-card-content>
        @if(requestInProgress$) {
        <strong>Request issued. Waiting on response from server</strong>
        } @else {
        <mat-form-field [style.width]="'100%'">
          <mat-label>{{ responseLabel$ }}</mat-label>
          <textarea matInput readonly cols="100" rows="12" [style.resize]="'none'">{{ responseBody$ }}</textarea>
        </mat-form-field>
        }
      </mat-card-content>
    </mat-card>
  </mat-grid-tile>
</mat-grid-list>
